module.exports = __webpack_public_path__ + "media/images/anchor_link03_sp-cf4fe872fa15bd28717830165c2c9515.png";